<h1 mat-dialog-title>{{ 'protocolEdit.dialog.essay.sensorsTitle' | translate }}</h1>
<form>
    <div mat-dialog-content class="thermal-theme">

        <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.essay.sensorsTitle' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="data.sensors" name="sensors" rows="5" matAutosizeMinRows="5" cdkTextareaAutosize style="resize: none;"></textarea>
        </mat-form-field>

    </div>
    <div mat-dialog-action class="thermal-theme">
        <div fxFlex></div>

        <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>
            {{ 'button.save' | translate }}</button>

        <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
    </div>

</form>